// 获取所有数据
export const GET_PREPAYMENT_DATA = 'GET_PREPAYMENT_DATA'

// 返回所有数据
export const GET_PREPAYMENT_DETAIL = 'GET_PREPAYMENT_DETAIL'

// 设置所有数据
export const SET_PREPAYMENT_DETAIL = 'SET_PREPAYENT_DETAIL'

// 确认还款
export const ADVANCE_CONFIRM = 'ADVANCE_CONFIRM'

// 设置还款数据
export const SET_BALANCED_SUM_STATE = 'SET_BALANCED_SUM_STATE'

// 部分提前还款金额
export const GET_PART_PREPAYMENT_MONEY = 'GET_PART_PREPAYMENT_MONEY'



// WEBPACK FOOTER //
// ./src/vuex/types/personaCenter/prepayment.js